export const fallbackProducts = {
    "products": [{
        "b": ["New"],
        "c": "USD",
        "d": "Washable cap",
        "f": 0,
        "id": "6979999334560",
        "iso": false,
        "l": "Washable Ccap",
        "p": "10",
        "p_c": "0",
        "p_max": "",
        "p_max_c": "0",
        "p_min": "",
        "p_min_c": "0",
        "p_spl": 0,
        "s": "6979999334560::40905704767648",
        "sku": "",
        "skus": [""],
        "t": "https://cdn.shopify.com/s/files/1/0343/9177/products/fe451c90-fba2-4060-9324-b14763850736_20136bc1-317e-465f-a67a-bf73b774e8a4_600x.jpg?v=1610312494",
        "t2": "https://cdn.shopify.com/s/files/1/0343/9177/products/6dfb54fe-befb-4a1e-8fe2-0bf8ca9eb0de_2000x.jpg?v=1610312494",
        "u": "/products/cap",
        "v": "stav2-test",
        "v_c": 1,
        "vra": [[40905704767648, [["Sellable", [true]], ["Title", ["Default Title"]]]]],
        "vrc": {}
    }, {
        "c": "USD",
        "d": "",
        "f": 0,
        "id": "6979999367328",
        "iso": false,
        "l": "Unisex Vogue Cotton Beanie",
        "p": "20",
        "p_c": "40",
        "p_max": "",
        "p_max_c": "0",
        "p_min": "",
        "p_min_c": "0",
        "p_spl": 0,
        "s": "6979999367328::40905704833184",
        "sku": "",
        "skus": [""],
        "t": "https://cdn.shopify.com/s/files/1/0343/9177/products/b28354da-e38d-485b-a5db-49b4dc8fca38_3380bebc-325c-4cf7-8870-1794948b9215_2000x.jpg?v=1610312508",
        "t2": "https://cdn.shopify.com/s/files/1/0343/9177/products/16eb51d7-5da2-445c-a327-53c659f28afb_fc8c3318-92e3-4265-93b0-005b39c86a7c_2000x.jpg?v=1610312508",
        "u": "/products/beanie",
        "v": "stav2-test",
        "v_c": 1,
        "vra": [[40905704833184, [["Price", ["USD:20.00"]], ["Sellable", [true]], ["Size", ["big"]]]]],
        "vrc": {}
    }, {
        "c": "USD",
        "d": "",
        "f": 0,
        "id": "6979999400096",
        "iso": false,
        "l": "Plaid Scarf Hat",
        "p": "50",
        "p_c": "0",
        "p_max": "",
        "p_max_c": "",
        "p_min": "",
        "p_min_c": "",
        "p_spl": 0,
        "s": "6979999400096::40905704865952",
        "sku": "",
        "skus": [""],
        "t": "https://cdn.shopify.com/s/files/1/0343/9177/products/a3ef1777-d00e-42c5-9b72-652a58870852_a61b39ce-1367-428f-b236-4048a8f6e7d9_800x.jpg?v=1610312479",
        "t2": "",
        "u": "/products/haat",
        "v": "kraka",
        "v_c": 1,
        "vra": [[40905704865952, [["Price", ["USD:980.00"]], ["Sellable", [true]], ["Title", ["Default Title"]]]]],
        "vrc": {}
    }, {
        "b": ["New", "Sale"],
        "c": "USD",
        "d": "",
        "f": 0,
        "id": "6979999432864",
        "iso": false,
        "l": "Baseball Cap",
        "p": "10",
        "p_c": "0",
        "p_max": "180",
        "p_max_c": "0",
        "p_min": "10",
        "p_min_c": "0",
        "p_spl": 0,
        "s": "6979999432864::40905704898720",
        "sku": "9599",
        "skus": ["9599", "9600", "9601", "9602", "9603", "18091994"],
        "t": "https://cdn.shopify.com/s/files/1/0343/9177/products/719f27a5-273c-4fea-9595-267a59f47333_a202ea0d-1baa-4bc9-b46d-b8fa6e72d867_600x.jpg?v=1610312468",
        "t2": "",
        "u": "/products/a-beautiful-creature",
        "v": "stav2-test",
        "v_c": 5,
        "vra": [[40905704898720, [["!@#", ["123"]], ["Barcode", ["18091994"]], ["Price", ["USD:180.00"]], ["Product-sku", ["9599"]], ["Sellable", [true]], ["Type", ["Loose Hair"]]]], [40905704931488, [["!@#", ["!!!"]], ["Price", ["USD:150.00"]], ["Product-sku", ["9600"]], ["Sellable", [true]], ["Type", ["chocolate on lips"]]]], [40905704964256, [["!@#", ["Wot!"]], ["Price", ["USD:10.00"]], ["Product-sku", ["9601"]], ["Sellable", [true]], ["Type", ["spiteful smile"]]]], [40905704997024, [["!@#", ["123"]], ["Price", ["USD:15.00"]], ["Product-sku", ["9602"]], ["Sellable", [true]], ["Type", ["9999"]]]], [40905705029792, [["!@#", ["123"]], ["Price", ["USD:16.00"]], ["Product-sku", ["9603"]], ["Sellable", [true]], ["Type", ["Hur2"]]]]],
        "vrc": {}
    }, {
        "c": "USD",
        "d": "",
        "f": 0,
        "id": "6979999531168",
        "iso": false,
        "l": "Breathable Baseball Cap",
        "p": "707",
        "p_c": "0",
        "p_max": "",
        "p_max_c": "0",
        "p_min": "",
        "p_min_c": "0",
        "p_spl": 0,
        "s": "6979999531168::40905705095328",
        "sku": "",
        "skus": [""],
        "t": "https://cdn.shopify.com/s/files/1/0343/9177/products/d2570216-9e18-4618-9925-2eaac04a7f3b_2000x.jpg?v=1610312442",
        "t2": "https://cdn.shopify.com/s/files/1/0343/9177/products/dbd92325-7687-43f0-8bce-b176535a3ec4_a16afe92-fd82-49c1-9fa7-8f9c886e210b_800x.jpg?v=1610312442",
        "u": "/products/derp",
        "v": "stav2-test",
        "v_c": 1,
        "vra": [[40905705095328, [["Price", ["USD:707.00"]], ["Sellable", [true]], ["Title", ["Default Title"]]]]],
        "vrc": {}
    },
    {
        "b": ["New"],
        "c": "USD",
        "d": "Adjustable cap",
        "f": 0,
        "id": "6979999334560",
        "iso": false,
        "l": "Adjustable Cap",
        "p": "0",
        "p_c": "0",
        "p_max": "",
        "p_max_c": "0",
        "p_min": "",
        "p_min_c": "0",
        "p_spl": 0,
        "s": "6979999334560::40905704767648",
        "sku": "",
        "skus": [""],
        "t": "https://cdn.shopify.com/s/files/1/0343/9177/products/0be96e78-aec2-4511-859d-5fa87f762aaa_400x.jpg?v=1610312437",
        "t2": "https://cdn.shopify.com/s/files/1/0343/9177/products/20140303173330033_9414450b-a168-45ce-9de5-66c8a23b76c4_600x.jpg?v=1610312437",
        "u": "/products/schnitzel",
        "v": "stav2-test",
        "v_c": 1,
        "vra": [[40905704767648, [["Sellable", [true]], ["Title", ["Default Title"]]]]],
        "vrc": {}
    },]
}
